/* eslint-disable no-restricted-imports */
import { scrollContainerSX } from '@/components/blocks/ScrollContainer/style/container';
import { combineSX } from '@/utils/combineSX';
import { Box, BoxProps, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useCentralContainerRemainingSpace } from 'integration/hooks/useCentralContainerRemainingSpace';
import { useScrollbarWidth } from 'integration/hooks/useScrollbarWidth';
import React, { forwardRef, PropsWithChildren, Ref } from 'react';

import { DpH2 } from '@/components/blocks/DpLibrary/DPText';
import { parseHTML } from '@/utils/parseHTML';
import { DpContainer } from '../DpContainer';

export const ScrollContainer = forwardRef(
	({ children, sx, ...props }: PropsWithChildren<BoxProps>, ref: Ref<HTMLDivElement>) => (
		<Box ref={ref} sx={combineSX([scrollContainerSX, sx])} {...props}>
			{children}
		</Box>
	)
);
interface DpScrollContainerProp extends BoxProps {
	title?: string;
	icon?: string;
	endicon?: string;
	href?: string;
}
export const DpScrollContainer = forwardRef(
	(
		{
			children,
			sx,
			title,
			icon,
			endicon,
			href,
			...props
		}: PropsWithChildren<DpScrollContainerProp>,
		ref: Ref<HTMLDivElement>
	) => {
		const spacing = useCentralContainerRemainingSpace();
		const theme = useTheme();
		const isBigScreen = useMediaQuery(theme.breakpoints.up(2000));

		const scrollBarWidth = useScrollbarWidth();
		return (
			<React.Fragment>
				{title ? (
					<DpContainer withoutmargin>
						<DpH2 href={href}>
							<Grid
								sx={{
									display: 'flex',
									flexDirection: 'row',
									maxWidth: '1280px',
									gap: '10px',
									width: '100%',
									marginBottom: { xs: '20px', sm: '30px' },
									justifyContent: 'start',
									alignItems: 'center',
								}}
							>
								{icon ? <Box sx={{ fontSize: '30px' }}>{parseHTML(icon)}</Box> : null}
								<DpH2 sx={{ marginBottom: 0 }}>{title}</DpH2>
								{endicon ? <Box sx={{ fontSize: '30px' }}>{parseHTML(endicon)}</Box> : null}
							</Grid>
						</DpH2>
					</DpContainer>
				) : null}
				{title ? (
					<Grid position="relative" spacing={1} display="grid">
						<Box
							sx={{
								height: '38px',
								width: '38px',
								position: 'absolute',
								top: '45%',
								left: '48px',
							}}
						/>
						<Box
							ref={ref}
							sx={combineSX([
								scrollContainerSX,
								{
									display: 'flex',
									flexDirection: 'row',
									maxWidth: `calc(100vw - (${scrollBarWidth}px + 0px))`,
									marginLeft: `calc(${spacing})`,
									paddingRight: `calc(${spacing} - (${scrollBarWidth}px + 20px))`,
									gap: '20px',
								},
								...(Array.isArray(sx) ? sx : [sx]),
							])}
							{...props}
						>
							{children}
						</Box>
						<Box></Box>
					</Grid>
				) : (
					<Box
						ref={ref}
						sx={combineSX([
							scrollContainerSX,
							{
								display: 'flex',
								flexDirection: 'row',
								maxWidth: `calc(100vw - (${scrollBarWidth}px + 0px))`,
								marginLeft: `calc(${spacing})`,
								paddingRight: `calc(${
									Number(spacing.split('px')[0]) / (isBigScreen ? 6.5 : 3.6)
								}px - (${scrollBarWidth}px + 20px))`,
								gap: '20px',
							},
							...(Array.isArray(sx) ? sx : [sx]),
						])}
						{...props}
					>
						{children}
					</Box>
				)}
			</React.Fragment>
		);
	}
);
